export default {
  'add-media': 'Add media',
}
